import React from "react";
import {
  Users,
  GraduationCap,
  BookMarked,
  HeartHandshake,
  Coins,
  Database,
} from "lucide-react";
import { SECTIONS } from "@/constants/testIds";

const OUTPUTS = [
  {
    icon: Users,
    title: "Community Bush Maps",
    body:
      "Wall-sized illustrated maps for ranger bases, community halls and Elder gatherings.",
  },
  {
    icon: GraduationCap,
    title: "School Resources",
    body:
      "Classroom-ready maps and field guides that bring Country into the curriculum.",
  },
  {
    icon: BookMarked,
    title: "Ranger Field Guides",
    body:
      "Pocket and on-Country reference handbooks for ranger teams and seasonal work.",
  },
  {
    icon: HeartHandshake,
    title: "Healthy Country Planning Maps",
    body:
      "Strategic visualisations that anchor planning, monitoring and decision-making.",
  },
  {
    icon: Coins,
    title: "Funding & Investment Maps",
    body:
      "Compelling visual cases for grants, partnerships and philanthropic investment.",
  },
  {
    icon: Database,
    title: "Digital Knowledge Systems",
    body:
      "Interactive, layered, community-owned digital archives that grow over time.",
  },
];

export default function ProjectOutputs() {
  return (
    <section
      id="outputs"
      data-testid={SECTIONS.outputs}
      className="relative py-24 md:py-32 bg-[#2C3C2B] text-[#FDFBF7] bm-noise"
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 z-10">
        <div className="max-w-3xl mb-16">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[#E9C7A8] font-semibold mb-6">
            Section 08 — Outputs
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#FDFBF7]">
            Project Outputs
          </h2>
          <p className="mt-6 text-[#D7CFC0] text-lg leading-relaxed">
            From wall-sized prints to digital interactive knowledge systems — every
            project is shaped around what is most useful for community,
            rangers and partners.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#3A4D39]">
          {OUTPUTS.map(({ icon: Icon, title, body }, i) => (
            <article
              key={title}
              className="bg-[#2C3C2B] p-8 lg:p-10 hover:bg-[#34452F] transition-colors"
            >
              <div className="flex items-start justify-between mb-8">
                <span className="w-12 h-12 rounded-full border border-[#E9C7A8] text-[#E9C7A8] flex items-center justify-center">
                  <Icon size={20} />
                </span>
                <span className="font-serif-display text-2xl text-[#6E7E68]">
                  / {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-serif-display text-2xl md:text-3xl text-[#FDFBF7] leading-tight">
                {title}
              </h3>
              <p className="mt-3 text-[#D7CFC0] leading-relaxed text-[15px]">
                {body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
